var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocalsFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_710_1770)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.75 4C4.02065 4 3.32118 4.28973 2.80546 4.80546C2.28973 5.32118 2 6.02065 2 6.75V17.25C2 17.6111 2.07113 17.9687 2.20933 18.3024C2.34753 18.636 2.5501 18.9392 2.80546 19.1945C3.06082 19.4499 3.36398 19.6525 3.69762 19.7907C4.03127 19.9289 4.38886 20 4.75 20H19.25C19.6111 20 19.9687 19.9289 20.3024 19.7907C20.636 19.6525 20.9392 19.4499 21.1945 19.1945C21.4499 18.9392 21.6525 18.636 21.7907 18.3024C21.9289 17.9687 22 17.6111 22 17.25V11.75C22 11.0207 21.7103 10.3212 21.1945 9.80546C20.6788 9.28973 19.9793 9 19.25 9H17V6.75C17 6.02065 16.7103 5.32118 16.1945 4.80546C15.6788 4.28973 14.9793 4 14.25 4H4.75ZM3.5 6.75C3.5 6.06 4.06 5.5 4.75 5.5H14.25C14.94 5.5 15.5 6.06 15.5 6.75V9.75C15.5 10.164 15.836 10.5 16.25 10.5H19.25C19.94 10.5 20.5 11.06 20.5 11.75V17.25C20.5 17.94 19.94 18.5 19.25 18.5H17V14.5C17 14.3011 16.921 14.1103 16.7803 13.9697C16.6397 13.829 16.4489 13.75 16.25 13.75C16.0511 13.75 15.8603 13.829 15.7197 13.9697C15.579 14.1103 15.5 14.3011 15.5 14.5V18.5H4.75C4.06 18.5 3.5 17.94 3.5 17.25V6.75Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_710_1770"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalsFilter);
export default __webpack_public_path__ + "static/media/locals_filter.06f4f7974876e5adf9fb2120f44a40cf.svg";
export { ForwardRef as ReactComponent };